import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaColaboradoresColaboradorConceptoDias', {
    template: template,
    controller: NominaColaboradoresColaboradorConceptoDiasComponent,
    require: {
      parent: '^nominaColaboradoresColaboradorConcepto',
    },
    bindings: {
      data: '<',
      onChange: '&',
    },
  })

function NominaColaboradoresColaboradorConceptoDiasComponent($parse) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.calcular = calcular
  $ctrl.validar = validar

  function $onInit() {
    $ctrl.editable = $ctrl.parent.editable
    $ctrl.calculo = $parse($ctrl.parent.calculo)
  }

  function calcular() {
    let scope = {
      data: $ctrl.data,
      colaborador: {
        config: {
          salario_diario: $ctrl.parent.salarioDiario,
        },
      },
    }

    $ctrl.calculo(scope)

    $ctrl.data = scope.data

    validar()
  }

  function validar() {
    $ctrl.onChange({
      $event: {
        data: ($ctrl.data && $ctrl.data.importe) ? $ctrl.data : null,
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/colaborador/concepto/dias/component.js